var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#1D4469",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2826 11.1072C11.6013 11.1072 12.6702 10.0386 12.6702 8.7203C12.6702 7.40204 11.6013 6.33337 10.2826 6.33337C8.96399 6.33337 7.89502 7.40204 7.89502 8.7203C7.89502 10.0386 8.96399 11.1072 10.2826 11.1072Z",
    fill: "#1D4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9012 15.2353C10.4502 14.751 10.1741 14.1017 10.1741 13.3883C10.1741 12.6579 10.4636 11.9943 10.9342 11.5065C10.7215 11.49 10.504 11.4813 10.2826 11.4813C8.84051 11.4813 7.5638 11.842 6.77112 12.3823C6.1664 12.7946 5.83301 13.3184 5.83301 13.8683V14.4975C5.83301 14.6933 5.91071 14.8812 6.04919 15.0192C6.18767 15.1576 6.37521 15.2353 6.57099 15.2353H10.9012Z",
    fill: "#1D4469"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8873 11.1098C11.6292 11.1098 10.6082 12.1306 10.6082 13.3883C10.6082 14.646 11.6292 15.6667 12.8873 15.6667C14.1453 15.6667 15.1663 14.646 15.1663 13.3883C15.1663 12.1306 14.1453 11.1098 12.8873 11.1098ZM11.8385 13.7676L12.4896 14.2016C12.6186 14.2875 12.7909 14.2706 12.9003 14.1608L13.9856 13.0758C14.1128 12.9491 14.1128 12.7425 13.9856 12.6158C13.8588 12.4886 13.6522 12.4886 13.5254 12.6158L12.6285 13.512L12.1996 13.226C12.0503 13.1261 11.848 13.1669 11.7482 13.3162C11.6483 13.4655 11.6891 13.6678 11.8385 13.7676Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/GroupIcon.6e5f1efff212ea9d1219550364fda781.svg";
export { ForwardRef as ReactComponent };